import _defineProperty from "/home/runner/work/995749721/995749721/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/runner/work/995749721/995749721/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "needFocusing", "events", "className", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useLayoutEffect } from "react";

var KeyCodes = {
  MAC_ENTER: 3,
  BACKSPACE: 8,
  TAB: 9,
  NUM_CENTER: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  QUESTION_MARK: 63,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  META: 91,
  WIN_KEY_RIGHT: 92,
  CONTEXT_MENU: 93,
  NUM_ZERO: 96,
  NUM_ONE: 97,
  NUM_TWO: 98,
  NUM_THREE: 99,
  NUM_FOUR: 100,
  NUM_FIVE: 101,
  NUM_SIX: 102,
  NUM_SEVEN: 103,
  NUM_EIGHT: 104,
  NUM_NINE: 105,
  NUM_MULTIPLY: 106,
  NUM_PLUS: 107,
  NUM_MINUS: 109,
  NUM_PERIOD: 110,
  NUM_DIVISION: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUMLOCK: 144,
  SEMICOLON: 186,
  DASH: 189,
  EQUALS: 187,
  COMMA: 188,
  PERIOD: 190,
  SLASH: 191,
  APOSTROPHE: 192,
  SINGLE_QUOTE: 222,
  OPEN_SQUARE_BRACKET: 219,
  BACKSLASH: 220,
  CLOSE_SQUARE_BRACKET: 221,
  WIN_KEY: 224,
  MAC_FF_META: 224,
  WIN_IME: 229,
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var s = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey || s >= KeyCodes.F1 && s <= KeyCodes.F12) return !1;

    switch (s) {
      case KeyCodes.ALT:
      case KeyCodes.CAPS_LOCK:
      case KeyCodes.CONTEXT_MENU:
      case KeyCodes.CTRL:
      case KeyCodes.DOWN:
      case KeyCodes.END:
      case KeyCodes.ESC:
      case KeyCodes.HOME:
      case KeyCodes.INSERT:
      case KeyCodes.LEFT:
      case KeyCodes.MAC_FF_META:
      case KeyCodes.META:
      case KeyCodes.NUMLOCK:
      case KeyCodes.NUM_CENTER:
      case KeyCodes.PAGE_DOWN:
      case KeyCodes.PAGE_UP:
      case KeyCodes.PAUSE:
      case KeyCodes.PRINT_SCREEN:
      case KeyCodes.RIGHT:
      case KeyCodes.SHIFT:
      case KeyCodes.UP:
      case KeyCodes.WIN_KEY:
      case KeyCodes.WIN_KEY_RIGHT:
        return !1;

      default:
        return !0;
    }
  },
  isCharacterKey: function isCharacterKey(e) {
    if (e >= KeyCodes.ZERO && e <= KeyCodes.NINE) return !0;
    if (e >= KeyCodes.NUM_ZERO && e <= KeyCodes.NUM_MULTIPLY) return !0;
    if (e >= KeyCodes.A && e <= KeyCodes.Z) return !0;
    if (-1 !== window.navigator.userAgent.indexOf("WebKit") && 0 === e) return !0;

    switch (e) {
      case KeyCodes.SPACE:
      case KeyCodes.QUESTION_MARK:
      case KeyCodes.NUM_PLUS:
      case KeyCodes.NUM_MINUS:
      case KeyCodes.NUM_PERIOD:
      case KeyCodes.NUM_DIVISION:
      case KeyCodes.SEMICOLON:
      case KeyCodes.DASH:
      case KeyCodes.EQUALS:
      case KeyCodes.COMMA:
      case KeyCodes.PERIOD:
      case KeyCodes.SLASH:
      case KeyCodes.APOSTROPHE:
      case KeyCodes.SINGLE_QUOTE:
      case KeyCodes.OPEN_SQUARE_BRACKET:
      case KeyCodes.BACKSLASH:
      case KeyCodes.CLOSE_SQUARE_BRACKET:
        return !0;

      default:
        return !1;
    }
  }
},
    keyReg = /^on(Alt|Ctrl|Meta|Shift){0,4}([A-Z][a-z]*)+$/,
    splitKey = function splitKey(e) {
  return e.match(/[A-Z][a-z]*/g);
},
    isSpecialKey = function isSpecialKey(e) {
  return ["Alt", "Ctrl", "Meta", "Shift"].includes(e);
},
    validatKey = function validatKey(s, e) {
  var E = splitKey(e);

  if (E) {
    for (var _e = 0; _e < E.length; _e++) {
      var C = E[_e];

      if (isSpecialKey(C)) {
        if (!s["".concat(C.toLowerCase(), "Key")]) return !1;
      } else if (s.keyCode !== KeyCodes[C.toUpperCase()]) return !1;
    }

    return !0;
  }
},
    validPropName = function validPropName(e, s) {
  return !(!keyReg.test(s) || !validatKey(e, s));
},
    KEY_EVENT = "keydown",
    KeyEvent = function KeyEvent(e) {
  var s = e.children,
      E = e.needFocusing,
      C = e.events,
      a = e.className,
      t = e.style,
      K = _objectWithoutProperties(e, _excluded),
      o = useRef(null);

  return useLayoutEffect(function () {
    var e = o.current || window,
        s = function s(_s) {
      Object.keys(C).filter(function (e) {
        return validPropName(_s, e);
      }).forEach(function (e) {
        _s.stopPropagation(), _s.preventDefault(), C[e](_s);
      });
    };

    return e && e.addEventListener(KEY_EVENT, s), function () {
      e && e.removeEventListener(KEY_EVENT, s);
    };
  }, [C]), React.createElement(React.Fragment, null, React.createElement("div", _objectSpread({
    ref: E ? o : null,
    tabIndex: -1,
    className: a,
    style: t
  }, K), s));
};

export default KeyEvent;